import styled from 'styled-components';
export const Description = styled.p.withConfig({
  displayName: "partials__Description",
  componentId: "sc-1anviax-0"
})(["min-height:70px;margin-bottom:20px;"]);